import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  selectLeaguesSeasons,
  mapToDropdown,
} from '../../reducers/leagues_filter_values'
import { setConfigsSeason, selectConfigsSeason } from '../../reducers/leagues_configs'

import { GlgSelect } from 'SharedComponents'


const LeaguesConfigDropdowns = () => {
  const dispatch = useDispatch()

  const seasons = useSelector(selectLeaguesSeasons)
  const dropdownSeasons = mapToDropdown(seasons)
  const configsSeason = useSelector(selectConfigsSeason)

  React.useEffect(() => {
    if (dropdownSeasons.length && !configsSeason?.value) {
      dispatch(setConfigsSeason(dropdownSeasons[0]))
    }
  }, [])

  return (
    <div className={'cls-lcd-sc-container'}>
    <div className={'dropdowns-grid'}>
      {/* Season */}
      <div className={'dropdown-wrapper'}>
        <span className={'dropdown-label'}>
          {window.I18n.t('clone_leagues_sessions.general.season')}
        </span>
        <span>
          <GlgSelect
            onChange={(seasonID) =>
              dispatch(setConfigsSeason(
                { value: seasonID, label: seasons[seasonID] },
              ))
            }
            value={configsSeason?.value}
            selectorClassName={'dropdown-select'}
            items={dropdownSeasons}
          />
        </span>
      </div>
    </div>
  </div>)
}

export default LeaguesConfigDropdowns
